export default __webpack_public_path__ + "static/media/Town house main cover.da36fbf1.jpg";